export default "__VITE_ASSET__BjxGAiZs__"